module.exports = __webpack_public_path__ + "static/img/c0bb153d92e5e56e34e0bf846b681649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T31.jpg
// module id = tjFt
// module chunks = 1